import { NetworkStatusBanner } from "app/features/network/molecules/NetworkStatusBanner";
import { useVersion } from "app/hooks/useVersion";
import { Stack } from "expo-router";
import { View, Text } from "react-native";

export default function GuestLayout() {
  const { version } = useVersion();

  return (
    <View className="flex-1 bg-white">
      <NetworkStatusBanner />
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      />
      <View className="pb-2">
        <Text className="text-xs text-center text-gray-400">{version}</Text>
      </View>
    </View>
  );
}
